import styled from "styled-components"
import { Group, Stack } from "@quorumus/plum"
import type { Party } from "QuorumGrassroots/widgets/ReusableComponents/OfficialCard/OfficialCard.types"

export const CardContainer = styled.div<{ isClickable: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    height: 64px;
    padding: 0px 16px;
    border-radius: 8px;
    background-color: var(--plum-white, #ffffff);
    border: 1px solid var(--plum-gray-4, #ced4da);
    cursor: ${({ isClickable }) => (isClickable ? "pointer" : "default")};
    transition:
        box-shadow 0.2s ease,
        transform 0.2s ease,
        border-color 0.2s ease;

    &:hover {
        ${({ isClickable }) =>
            isClickable
                ? `
                      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                      border-color: var(--plum-gray-5, #adb5bd);
                      transform: translateY(-1px);
                  `
                : ""};
    }
`

export const LeftContentGroup = styled(Group)`
    flex: 1;
    gap: 12px;
`

export const InfoStack = styled(Stack)`
    flex: 1;
    gap: 2px;
    min-width: 0;
`

export const NameRow = styled(Group)`
    gap: 8px;
    align-items: center;
`

export const NameText = styled.span`
    font-size: 16px;
    font-weight: 500;
    color: var(--plum-gray-9, #000000);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const RoleText = styled.span`
    font-size: 12px;
    font-weight: 400;
    color: var(--plum-gray-7, #495057);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const ActionsGroup = styled(Group)`
    flex-wrap: nowrap;
    gap: 8px;
`

export const PartyBadge = styled.div<{ party: Party }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    flex-shrink: 0;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    color: #ffffff;
    line-height: 1;

    ${({ party }) => {
        switch (party) {
            case "democrat":
                return `background-color: #1f77b4;`
            case "republican":
                return `background-color: #e81b23;`
            default:
                return `background-color: #6c757d;`
        }
    }}
`
